<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>公司员工岗位管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="base-search-container">
            <swb-staff-role-search @queryHandler="queryHandler"></swb-staff-role-search>
        </div>
        <div class="table-layout mt10">
            <el-table :data="staffList" border style="width: 100%">
                <el-table-column prop="name" label="员工姓名" align="center" width="140"></el-table-column>
                <el-table-column prop="user.phoneNo" label="用户手机号" align="center" width="140"></el-table-column>
                <el-table-column prop="user.nickName" label="用户昵称" align="center" width="140"></el-table-column>
                <el-table-column prop="contactTel" label="联系电话" align="center" width="140"></el-table-column>
                <el-table-column prop="user.idCertNo" label="身份证号" align="center" width="200"></el-table-column>
                <el-table-column prop="enrollDate" label="入职时间" align="center" width="180"></el-table-column>
                <el-table-column prop="quit" label="是否离职" align="center" width="180">
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.quit">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="quitDate" label="离职时间" align="center" width="180"></el-table-column>
                <el-table-column prop="id" label="操作">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" v-if="checkActionPerm('staffRole')" @click="showStaffRoleDialog(rows.row)">分配岗位</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout mt10">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import userApi from '../../api/user'
    import retailerApi from '../../api/retailer'
    import retailerAuthxApi from '../../api/retailerAuthx'

    import SwbRoleList from './RoleList';
    Vue.regist(SwbRoleList);

    import SwbStaffRoleSearch from './StaffRoleSearch.vue';
    Vue.regist(SwbStaffRoleSearch);

    export default {
        name: 'swb-staff-role',
        path: '/com/staff/role',
        pathOld: '/staff/role',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '员工岗位',

        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                staffList: [],
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        mounted: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == "info") {
                    self.userContext = result.data;
                    self.getStaffList();
                }
            });
        },
        methods: {
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            queryHandler: function (data) {
                this.queryModel = data;
                this.getStaffList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getStaffList();
            },
            getStaffList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.comId = self.userContext.scopeEntity.comId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerStaffList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.staffList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            showStaffRoleDialog: function (item) {
                let theDlg = Vue.$showDialog({
                    title: "分配岗位",
                    showCloseBtn: true,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-role-list :staff="staff" ref="swb_staffRole"></swb-role-list>' +
                    '</div>',
                    data: {
                        loading: false,
                        staff: {},
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_staffRole.getDlgResult() || {};
                        if(result.type === 'info') {
                            let data = result.data;
                            selfDlg.loading = true;
                            selfDlg.replaceStaffRole(data);
                        } else {
                            this.$message.error(result.message);
                        }
                        return false;
                    },
                    methods: {
                        replaceStaffRole (data) {
                            let selfDlg = this;
                            let post_data = {};
                            post_data.staffId = selfDlg.staff.id;
                            post_data.userId = selfDlg.staff.userId;
                            post_data.roleIds = data;
                            retailerAuthxApi.replaceRetailerStaffRole(post_data, function (result) {
                                selfDlg.loading = false;
                                if(result.type === "info") {
                                    theDlg.close();
                                    selfDlg.$message.success("添加成功");
                                } else {
                                    selfDlg.$message.error(result.message);
                                }
                            });
                        }
                    },
                    lifecycle: {
                        created: function () {
                            this.staff = Utils.merge({}, item);
                        }
                    }
                });
            },
        }
    }

</script>





// WEBPACK FOOTER //
// src/compo/authx/StaffRole.vue